import { Box, Typography, Paper, Button } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';

interface ErrorBoundaryProps {
  error: Error;
  reset?: () => void;
}

export function ErrorBoundary({ error, reset }: ErrorBoundaryProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: 'center',
          maxWidth: { xs: '90%', sm: 500 },
        }}
      >
        <ErrorOutline
          sx={{
            fontSize: 64,
            color: 'error.main',
            mb: 2,
          }}
        />

        <Typography variant='h5' component='h2' gutterBottom>
          Something went wrong
        </Typography>

        <Typography variant='body1' color='text.secondary' paragraph>
          {error.message || 'An unexpected error occurred'}
        </Typography>

        {import.meta.env.DEV && (
          <Typography
            variant='body2'
            component='pre'
            sx={{
              mt: 2,
              p: 2,
              bgcolor: 'grey.100',
              borderRadius: 1,
              textAlign: 'left',
              fontSize: '0.75rem',
              overflow: 'auto',
            }}
          >
            {error.stack}
          </Typography>
        )}

        {reset && (
          <Button variant='contained' onClick={reset} sx={{ mt: 2 }}>
            Try Again
          </Button>
        )}
      </Paper>
    </Box>
  );
}
